export default ({reader}) => `plugins {
  id 'com.android.application'
  id 'kotlin-android'
  id 'kotlin-kapt'
}

android {
  compileSdkVersion 29

  defaultConfig {
      minSdkVersion 29
      targetSdkVersion 29
  }

  compileOptions {
    sourceCompatibility JavaVersion.VERSION_1_8
    targetCompatibility JavaVersion.VERSION_1_8
  }

  kotlinOptions {
    jvmTarget = '1.8'
  }
}

dependencies {
  implementation fileTree(dir: 'libs', include: ['*.jar'])

  implementation "com.google.android.material:material:1.1.0"
  implementation "androidx.appcompat:appcompat:1.2.0"
  implementation "org.jetbrains.kotlin:kotlin-stdlib-jdk7:1.4.10"
  implementation "androidx.constraintlayout:constraintlayout:2.0.2"
  {+load-stripe}
  implementation "com.stripe:stripeterminal:2.4.1"
  {/load-stripe}

  implementation "com.facebook.stetho:stetho-okhttp3:1.5.1"
  implementation "com.squareup.retrofit2:retrofit:2.9.0"
  implementation "com.squareup.retrofit2:converter-gson:2.9.0"

  implementation "androidx.lifecycle:lifecycle-runtime:2.2.0"
  implementation "androidx.lifecycle:lifecycle-extensions:2.2.0"
  kapt "androidx.lifecycle:lifecycle-compiler:2.2.0"
}
`;
